import { Box } from "@mui/system"
import { useTheme } from "@mui/material/styles"
import CheckIcon from "@mui/icons-material/CheckCircle"
import CloseIcon from "@mui/icons-material/Cancel"
import { DriverInfo, VehicleInfo } from "types/list-card-holder"

export const CardHolderAutochargeCell = ({
    driver,
}: {
    driver: DriverInfo | VehicleInfo
}) => {
    const theme = useTheme()

    const hasAutocharge = (driver as VehicleInfo).autochargeEnabled
    return (
        <Box
            sx={{
                display: "inline-flex",
                color: hasAutocharge
                    ? theme.palette.success.main
                    : theme.palette.error.main,
                fontSize: 22,
            }}
        >
            {hasAutocharge ? <CheckIcon /> : <CloseIcon />}
        </Box>
    )
}
